import { render, staticRenderFns } from "./OverviewForm.vue?vue&type=template&id=4bce44f3&scoped=true"
import script from "./OverviewForm.vue?vue&type=script&lang=js"
export * from "./OverviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce44f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bce44f3')) {
      api.createRecord('4bce44f3', component.options)
    } else {
      api.reload('4bce44f3', component.options)
    }
    module.hot.accept("./OverviewForm.vue?vue&type=template&id=4bce44f3&scoped=true", function () {
      api.rerender('4bce44f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/OverviewForm.vue"
export default component.exports